export interface CompetitorContributionProductTotals {
    primary: number;
    comparison: number;
}

export interface ContributionProductRow {
    contributionProduct?: number | null;
}

/**
 * Sums the contribution product across every row in the given dataset.
 */
export const sumContributionProduct = (
    rows: ContributionProductRow[] | undefined,
): number => {
    if (!rows || rows.length === 0) {
        return 0;
    }

    return rows.reduce((acc, row) => {
        const val = Number(row.contributionProduct);
        return acc + (isNaN(val) ? 0 : val);
    }, 0);
};

/**
 * Calculates primary and comparison competitor contribution product totals from query row sets.
 */
export const calculateCompetitorContributionProductTotals = (
    primaryRows: ContributionProductRow[] | undefined,
    comparisonRows: ContributionProductRow[] | undefined,
): CompetitorContributionProductTotals => ({
    primary: sumContributionProduct(primaryRows),
    comparison: sumContributionProduct(comparisonRows),
});
